<template>
  <b-button
    @click="trigger"
    size="sm"
    variant="light"
    block
    >
    <i class="fa fa-map-marker-alt" />
  </b-button>
</template>

<script>
import common from '@/mixins/common.js'

export default {
  name: "ToCenter",
  mixins: [common],
  components: {
    
  },
  props: {
    
  },
  data: function() {
    return {
      
    }
  },
  watch: {
    
  },
  methods: {
    trigger() {
      this.$emit('click')
    },
    
  },
  mounted() {
    
  }
}
</script>

<style>
</style>
